import React, { useState } from 'react';

const Jobs = () => {
    const [applyStatus, setApplyStatus] = useState({});
    const [verificationCodes, setVerificationCodes] = useState({});
    const [needsVerification, setNeedsVerification] = useState({});

    // Hardcoded jobs for testing
    const jobs = [
        {
            job_id: 'linkedin_12345',
            title: 'Senior Software Engineer',
            company: 'Tech Corp',
            location: 'Remote',
            posted_date: '2024-03-15',
            source: 'LinkedIn',
            application_url: 'https://jobs.cvshealth.com/us/en/job/R0498869/Staff-Software-Development-Engineer'
        },
        {
            job_id: 'linkedin_12346',
            title: 'Full Stack Developer',
            company: 'Startup Inc',
            location: 'San Francisco, CA',
            posted_date: '2024-03-14',
            source: 'LinkedIn',
            application_url: 'https://linkedin.com/jobs/124'
        },
        {
            job_id: 'glassdoor_789',
            title: 'React Developer',
            company: 'Web Solutions',
            location: 'New York, NY',
            posted_date: '2024-03-13',
            source: 'Glassdoor',
            application_url: 'https://glassdoor.com/jobs/789'
        }
    ];

    const handleVerificationCodeChange = (jobId, code) => {
        setVerificationCodes(prev => ({ ...prev, [jobId]: code }));
    };

    const handleApply = async (jobId) => {
        try {
            setApplyStatus(prev => ({ ...prev, [jobId]: 'loading' }));
            
            const containerUrl = 'http://44.246.24.38:8000';
            
            const job = jobs.find(j => j.job_id === jobId);
            if (!job) {
                throw new Error('Job not found');
            }
            
            const user_id = 'b8c1c360-e031-70e5-d7f7-beea2e9d37d9';  // For testing
            const verificationCode = verificationCodes[jobId];
            
            console.log('Calling container endpoint:', `${containerUrl}/verify-application-url`);
            console.log('Request payload:', { 
                job_id: jobId, 
                application_url: job.application_url,
                user_id: user_id,
                verification_code: verificationCode,
                timestamp: new Date().toISOString() 
            });
            
            const response = await fetch(`${containerUrl}/verify-application-url`, {
                method: 'POST',
                mode: 'cors',
                credentials: 'omit',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
                body: JSON.stringify({ 
                    job_id: jobId,
                    application_url: job.application_url,
                    user_id: user_id,
                    verification_code: verificationCode,
                    timestamp: new Date().toISOString()
                })
            });

            const responseText = await response.text();
            console.log('Raw response:', responseText);

            let errorMessage = 'Failed to verify application URL';
            try {
                const data = JSON.parse(responseText);
                
                if (!response.ok) {
                    errorMessage = data.detail || errorMessage;
                    if (typeof data.detail === 'object') {
                        errorMessage = data.detail.error || errorMessage;
                    }
                    throw new Error(errorMessage);
                }

                console.log('Container response:', data);

                if (data.status === 'success') {
                    if (data.needs_verification) {
                        setNeedsVerification(prev => ({ ...prev, [jobId]: true }));
                        setApplyStatus(prev => ({ ...prev, [jobId]: 'verification_needed' }));
                        alert('Please check your email for verification code');
                    } else {
                        setApplyStatus(prev => ({ ...prev, [jobId]: 'success' }));
                        setNeedsVerification(prev => ({ ...prev, [jobId]: false }));
                        alert('Application submitted successfully!');
                    }
                } else {
                    console.error('Error response from container:', data);
                    setApplyStatus(prev => ({ ...prev, [jobId]: 'error' }));
                    alert(`Error: ${data.error || errorMessage}`);
                }
            } catch (err) {
                console.error('Error parsing response:', err);
                setApplyStatus(prev => ({ ...prev, [jobId]: 'error' }));
                alert(`Error: ${errorMessage}`);
            }
        } catch (err) {
            console.error('Error applying to job:', err);
            setApplyStatus(prev => ({ ...prev, [jobId]: 'error' }));
            alert(`Error: ${err.message}`);
        }
    };

    return (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            <h2 className="text-3xl font-bold text-gray-900 mb-8">Available Jobs</h2>
            <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
                {jobs.map(job => (
                    <div key={job.job_id} className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow duration-200">
                        <h3 className="text-xl font-semibold text-gray-900 mb-2">{job.title}</h3>
                        <div className="space-y-2 mb-4">
                            <p className="text-gray-600"><span className="font-medium">Company:</span> {job.company}</p>
                            <p className="text-gray-600"><span className="font-medium">Location:</span> {job.location}</p>
                            <p className="text-gray-600"><span className="font-medium">Posted:</span> {job.posted_date}</p>
                            <p className="text-gray-600"><span className="font-medium">Source:</span> {job.source}</p>
                        </div>
                        
                        {needsVerification[job.job_id] && (
                            <div className="mb-4">
                                <input
                                    type="text"
                                    placeholder="Enter verification code"
                                    className="w-full px-3 py-2 border rounded-md"
                                    value={verificationCodes[job.job_id] || ''}
                                    onChange={(e) => handleVerificationCodeChange(job.job_id, e.target.value)}
                                />
                            </div>
                        )}
                        
                        <button 
                            className={`w-full px-4 py-2 rounded-md font-medium text-white transition-colors duration-200 
                                ${applyStatus[job.job_id] === 'success' ? 'bg-green-600 hover:bg-green-700' :
                                  applyStatus[job.job_id] === 'error' ? 'bg-red-600 hover:bg-red-700' :
                                  applyStatus[job.job_id] === 'verification_needed' ? 'bg-yellow-500 hover:bg-yellow-600' :
                                  applyStatus[job.job_id] === 'loading' ? 'bg-yellow-500 hover:bg-yellow-600' :
                                  'bg-indigo-600 hover:bg-indigo-700'}
                                ${applyStatus[job.job_id] === 'loading' ? 'opacity-75 cursor-not-allowed' : ''}`}
                            disabled={applyStatus[job.job_id] === 'loading'}
                            onClick={() => handleApply(job.job_id)}
                        >
                            {applyStatus[job.job_id] === 'success' ? 'Applied' :
                             applyStatus[job.job_id] === 'error' ? 'Failed' :
                             applyStatus[job.job_id] === 'verification_needed' ? 'Submit Code' :
                             applyStatus[job.job_id] === 'loading' ? 'Applying...' :
                             'Apply'}
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Jobs; 